import React, { Component } from 'react'
import { Container } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'
import SubjectSection from '../components/learn_practice/subjects/SubjectSection'
import TopHeaderSection from '../components/learn_practice/top_header/TopHeaderSection';
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";

import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';
import { Row, Col, Card } from 'react-bootstrap';

// Inline shimmer skeleton mirroring the subjects header + chapter cards grid.
const SubjectsShimmer = () => (
    <div className="px-3 py-4">
        <div className="rz-shimmer rz-skel-title" style={{ width: '35%', height: '26px' }}></div>
        <div className="rz-shimmer rz-skel-line" style={{ width: '60%' }}></div>
        <Row className="mt-4">
            {Array.from({ length: 8 }).map((_, i) => (
                <Col xl={3} lg={4} md={6} sm={12} key={i} className="mb-4">
                    <Card className="rz-skel-card border-0">
                        <div className="d-flex align-items-center mb-3">
                            <div className="rz-shimmer rz-skel-circle mr-3" style={{ width: '46px', height: '46px' }}></div>
                            <div style={{ flex: 1 }}>
                                <div className="rz-shimmer rz-skel-line" style={{ width: '70%' }}></div>
                                <div className="rz-shimmer rz-skel-line sm mb-0" style={{ width: '40%' }}></div>
                            </div>
                        </div>
                        <div className="rz-shimmer rz-skel-line sm" style={{ width: '100%' }}></div>
                        <div className="rz-shimmer rz-skel-line sm" style={{ width: '85%' }}></div>
                        <div className="rz-shimmer rz-skel-btn mt-3" style={{ width: '100%' }}></div>
                    </Card>
                </Col>
            ))}
        </Row>
    </div>
);

const UPDATE_STUDENT_ANALYTICS = gql`
mutation(
  $params:AnalyticsStudents1  
  ) {
      studentAnalytics(
      params: $params
   )
}
`;


class Subjects extends Component {
    constructor(props){
        super(props)
        this.state={
            submitError:""

        }
    }

    componentDidMount = () => {
        this.addStudentAnalytics();

        const title = GoogleAnalyticsArray[0].Learn_Practice_Subject_Home;
        ReactGA.pageview('/student/subjects',["rizee"], title);
    }
    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
            analytics_module_page_id: 18,
            source: 2
        }


        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");
        const subjects = this.props.subjects;
        const loading1 = subjects.loading;
        const error1 = subjects.error;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        console.log("subjectsch", (this.props.history.location.state || {}).subjectid);
        let subjectsData = "";
        if (subjects.getSubjects != undefined) {
            subjectsData = subjects.getSubjects.find((a) => a.id == (this.props.history.location.state || {}).subjectid);

        }
        // No subject to show (page opened directly or refreshed without a
        // subject, or a subject from an exam the student switched away from):
        // go to Learn & Practise instead of rendering a page that would crash.
        if (!loading1 && !subjectsData) {
            this.props.history.replace("/student/learn-practice");
            return null;
        }
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        {loading1 == true && (<SubjectsShimmer />)}
                        {
                            !loading1 && (
                                <React.Fragment>
                                    <TopHeaderSection
                                        subjectsData={subjectsData}
                                        getChapters={this.props.history.location.state != undefined ? this.props.history.location.state : ""} />
                                    <Container fluid={true}>

                                        <SubjectSection
                                            subjectsData={subjectsData}
                                            getChapters={this.props.history.location.state != undefined ? this.props.history.location.state : ""} />

                                    </Container>
                                </React.Fragment>


                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(compose(
    graphql(gql` 
    query($student_user_exam_id: Int!,
        $exam_id: Int,
        $class_id: Int,$subject: Int) {
        getSubjects(student_user_exam_id: $student_user_exam_id,
        exam_id: $exam_id,
        class_id: $class_id, subject: $subject){
            id
            last_attempted_chapter
            accuracy
            }
    }
    `,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                    exam_id: parseInt(Cookies.get("examid")),
                    class_id: parseInt(Cookies.get("classid")),
                    subject: parseInt((props.history.location.state || {}).subjectid)
                },
                fetchPolicy: 'cache-and-network'
            }),
            name: "subjects"
        }),
        graphql(UPDATE_STUDENT_ANALYTICS, {
            name: "submitpt"
        }),
        )(Subjects));
